import styled from "styled-components";

const TextWrapper = styled.div`
  h1,h2,h3,h4,h5,h6 {
    color: #224C5D;
  }
  a {
    color: #124d60 !important;
    text-decoration: none;
  }
`;

const S = {
  TextWrapper,
};

export default S;